import {useEffect} from 'react'
import {useRouteError} from 'react-router-dom'
import * as Sentry from '@sentry/react'

// Data-router errors still reach the existing exception tracker. The fallback
// shows no raw error message, stack, or private data.
export default function RootRouteError(){
  const error=useRouteError()
  useEffect(()=>{Sentry.captureException(error)},[error])
  return <main className="p-8 max-w-xl mx-auto"><h1 className="text-xl font-semibold mb-3">Something went wrong</h1><p className="mb-4">This page could not be opened. Reload it, or return to the dashboard.</p><div className="flex gap-3"><button className="border rounded-md px-3 py-2" onClick={()=>window.location.reload()}>Reload page</button><button className="border rounded-md px-3 py-2" onClick={()=>{window.location.href='/'}}>Go to dashboard</button></div></main>
}
